import {
  AddressBook,
  CalendarDots,
  Compass,
  Files,
  type Icon,
  MagnifyingGlass,
  SquaresFour,
  ThumbsUp,
  UserCirclePlus,
} from "@phosphor-icons/react";

import type { TagVariantType } from "common/components/ui/Tag";

import type { LeadListSourceType } from "./types";

export const LEAD_LIST_SOURCE_TYPES: Record<
  LeadListSourceType,
  {
    icon: Icon;
    label: string;
    subtitle: string;
    tagVariant: TagVariantType;
    iconContainerClassName: string;
  }
> = {
  search: {
    icon: MagnifyingGlass,
    label: "LinkedIn search",
    subtitle: "Search all of LinkedIn - 2nd & 3rd degree",
    tagVariant: "teal",
    iconContainerClassName: "border border-teal-200 bg-teal-50 text-teal-700",
  },
  navigator: {
    icon: Compass,
    label: "Sales Navigator",
    subtitle: "Advanced search with Sales Navigator filters",
    tagVariant: "info",
    iconContainerClassName: "border border-blue-200 bg-blue-100 text-blue-600",
  },
  post: {
    icon: ThumbsUp,
    label: "Post engagement",
    subtitle: "People who reacted to or commented on a post",
    tagVariant: "success",
    iconContainerClassName:
      "border border-green-200 bg-green-100 text-green-600",
  },
  event: {
    icon: CalendarDots,
    label: "Event Attendees",
    subtitle: "People attending a LinkedIn event",
    tagVariant: "danger",
    iconContainerClassName: "border border-red-200 bg-red-100 text-red-600",
  },
  group: {
    icon: UserCirclePlus,
    label: "Group Members",
    subtitle: "Members of a LinkedIn group",
    tagVariant: "magenta",
    iconContainerClassName:
      "border border-magenta-200 bg-magenta-100 text-magenta-600",
  },
  list: {
    icon: Files,
    label: "CSV List",
    subtitle: "Import contacts from a CSV file",
    tagVariant: "yellow",
    iconContainerClassName:
      "border border-yellow-200 bg-yellow-100 text-yellow-600",
  },
  crm: {
    icon: SquaresFour,
    label: "Connect CRM",
    subtitle: "Import contacts from your CRM",
    tagVariant: "secondary",
    iconContainerClassName:
      "border border-purple-200 bg-purple-100 text-purple-600",
  },
  drip: {
    icon: AddressBook,
    label: "Search your contacts",
    subtitle: "Search your existing contacts",
    tagVariant: "magenta",
    iconContainerClassName:
      "border border-magenta-200 bg-magenta-100 text-magenta-600",
  },
};
